import Pusher from "pusher-js";
import {getEnv} from "@/utils/env";
export const pusher = new Pusher(getEnv('VITE_PUSHER_KEY'), {
    wsHost: getEnv('VITE_PUSHER_HOST'),
    wsPort: getEnv('VITE_PUSHER_PORT'),
    wssPort: getEnv('VITE_PUSHER_PORT_SSL'),
    forceTLS: getEnv('VITE_PUSHER_FORCE_TLS') === 'true',
});
